import { useQuery } from "@tanstack/react-query";
import { PermissionsResponse } from "../lusca-search-api/generated-src";
import { PermissionsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

export type PermissionsState = PermissionsResponse & { isLoading: boolean };

const NO_PERMISSIONS: PermissionsResponse = {
  canRedrive: false,
  canDlqRedrive: false,
  canPsnsRedrive: false,
};

/** The caller's redrive permissions. Everything is denied until loaded and if the call fails. */
export default function usePermissions(): PermissionsState {
  const { data, isLoading } = useQuery<PermissionsResponse>(
    ["permissions"],
    async () => (await PermissionsApiFactory().getPermissions()).data,
    {
      staleTime: 10 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
  return { ...(data ?? NO_PERMISSIONS), isLoading };
}
